// apk里不支持Cookies
// import Cookies from 'js-cookie'

const AccessTokenKey = 'third_token'
const store = 'store'

export function getAccessToken() {
  return sessionStorage.getItem('jumper_access_token') || sessionStorage.getItem('third_token')
}

export function setAccessToken(token) {
  return sessionStorage.setItem(AccessTokenKey, token)
}

export function removeAccessToken() {
  return sessionStorage.removeItem(AccessTokenKey)
}

export function removeStore() {
  return window.sessionStorage.removeItem(store)
}
